import { connect } from 'react-redux';

import * as stepThreeModule from '../../modules/stepThree';
import StepThree from '../../components/StepThree/StepThree';


const mapStateToProps = state => {
  const {
    selectedFirst,
    selectedSecond,
  } = state.stepOne;

  const {
    currentService,
  } = state.stepTwo;

  const {
    areaCode,
    selectedTab,
    selectedService,
    selectedTV,
    selectedInternet,
    selectedPhone,
    recomendedPlans,
    choosedPlans,
    showAll,
  } = state.stepThree;

  return {
    selectedFirst,
    selectedSecond,
    areaCode,
    currentService,
    selectedTab,
    selectedService,
    selectedTV,
    selectedInternet,
    selectedPhone,
    recomendedPlans,
    choosedPlans,
    showAll,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchSelectTab: selected => dispatch(stepThreeModule.selectTab(selected)),
    dispatchSelectService: selected => dispatch(stepThreeModule.selectService(selected)),
    dispatchSelectTV: selected => dispatch(stepThreeModule.selectTV(selected)),
    dispatchSelectInternet: selected => dispatch(stepThreeModule.selectInternet(selected)),
    dispatchSelectPhone: selected => dispatch(stepThreeModule.selectPhone(selected)),
    dispatchToggleShowAll: () => dispatch(stepThreeModule.toggleShowAll()),
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(StepThree);
